<a [routerLink]="elementoHijo.ruta" class="block group p-3 transition-all duration-200 rounded-xl hover:bg-indigo-50"
   (click)="onChildMenuClick()"
   [ngClass]="{ 'bg-indigo-50 shadow-xs': elementoHijo.activo }">
  <div class="flex items-start">
    <div class="shrink-0 mt-0.5 mr-3 bg-indigo-100 p-2 rounded-lg">
      <img [src]="'assets/img/iconos/' + elementoHijo.icono" alt="" height="20" width="20">
    </div>
    <div>
      <p class="text-sm font-medium text-gray-800 group-hover:text-indigo-600">{{ elementoHijo.titulo  | translate }}</p>
      <p class="mt-1 text-sm text-gray-600">{{ elementoHijo.descripcion  | translate }}</p>
    </div>
  </div>
</a>
